module.exports = __webpack_public_path__ + "img/q21n_25.prt.069ecc0c.jpg";